import {Expose} from 'class-transformer';

export class TagGroupTagApiModel {
  @Expose()
  orderNo: number;

  @Expose()
  symbol: string;

  @Expose()
  description: string;
}
